export default __webpack_public_path__ + "static/picExposition-41e84acd10f91af8805cc4091ad92e70.jpg";